// extracted by mini-css-extract-plugin
export default {"filters":"FoxStatsSports_filters__JwRWW","tabs":"FoxStatsSports_tabs__OhaI5","content":"FoxStatsSports_content__RqSuz"};